<script setup lang="ts">
import { inject, ref, type Ref } from 'vue';

const isDarkMode = inject<Ref<boolean>>('isDarkMode', ref(false));
</script>

<!-- Layout for external (public-link) users: header with the Gaia logo,
     no sidebar. External-access auth wiring lands in a follow-up. -->
<template>
  <n-layout position="absolute">
    <n-layout-header bordered>
      <n-space align="center" style="height: 100%; padding: 0 24px">
        <img src="@/assets/logo.svg" alt="Gaia" class="logo" :class="{ 'logo-dark': isDarkMode }" />
      </n-space>
    </n-layout-header>

    <n-layout-content content-style="padding: 0;">
      <router-view />
    </n-layout-content>
  </n-layout>
</template>

<style scoped>
:deep(.n-layout-content) {
  background-color: var(--body-color);
}

.logo {
  height: 32px;
  width: auto;
}

.logo-dark {
  filter: invert(1) brightness(100);
}
</style>
